import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { OldSolutionsSection } from './components/OldSolutionsSection';
import { ProtocolSection } from './components/ProtocolSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { PromiseAndCtaSection } from './components/PromiseAndCtaSection';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  const {
    trackAddToCart
  } = useMetaPixel();
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <OldSolutionsSection data-id="element-3" />
      <ProtocolSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <ForWhoSection data-id="element-7" />
      <PromiseAndCtaSection onAddToCart={trackAddToCart} data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}